/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import { Box, Skeleton, IconButton } from "@mui/material";
import MailIcon from "@mui/icons-material/Mail";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import TabView from "../../../components/Tabs";
import OfferCard from "../../../components/OfferCard";
import MarkEmailUnreadOutlinedIcon from "@mui/icons-material/MarkEmailUnreadOutlined";
import t from "../../../theme";
import DoYouKnowPlaceholder from "./DoYouKnowPlaceholder";
import CouponsList from "./CouponsList";

const MailGrid = ({
  classes,
  tabs,
  subCategoryList,
  isSubCatLoading,
  isBrandLoading,
  mailList,
  mailCount,
  isMailLoading,
  subCatActive,
  tabIndexs,
  setTabindexs,
  checkseen,
  onActivefunct,
  totalRedeemedPoints,
  totalMailCount,
  unreadMailCount,
  subscribeshow,
  setSubscribeShow,
  selBrand,
  selCategory,
  selCountry,
  selState,
  selCity,
  selCounty,
  userDetails,
  onTabChange,
  onFavouriteMailToggle,
  onUnsubscribeMail,
  onOfferCardClick,
  onMoreMailsClick,
  doYouKnowTabUuid,
  isDoYouKnowConfigured,
  isDoYouKnowLoading,
  doYouKnowError,
  hasDoYouKnowData,
  doYouKnowData,
  quickOffersTabUuid,
  isQuickOffersLoading,
  quickOffersError,
  quickOffersData,
  promotionsData,
}) => {
  const visibleTabs = tabs ?? subCategoryList;

  return (
    <>
      <div css={classes.statsContainer}>
        <div css={classes.switchContainer}>
          <div className="form-check form-switch">
            <span>All</span>
            <input
              className="form-check-input"
              type="checkbox"
              id="mailViewSwitch"
              checked={checkseen}
              onChange={() => onActivefunct(checkseen)}
            />
            <label className="form-check-label" htmlFor="mailViewSwitch">
              <span>Un Seen</span>
            </label>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div css={classes.statsText}>
            <MailIcon sx={{ fontSize: "0.95rem", color: "#2e7d32" }} />
            <span>Mails Unread:</span>
            <span css={classes.statsValue} style={{ color: "#2e7d32" }}>
              {unreadMailCount}
            </span>
            <span style={{ color: "rgba(0,0,0,0.25)", fontWeight: "400" }}>
              /
            </span>
            <span css={classes.statsValue} style={{ color: t.text.primary }}>
              {totalMailCount}
            </span>
          </div>
          <div css={classes.statsText}>
            <StarRoundedIcon sx={{ fontSize: "0.95rem", color: "#e6a817" }} />
            <span>Redeemed Points:</span>
            <span css={classes.statsValue} style={{ color: "#2e7d32" }}>
              {totalRedeemedPoints}
            </span>
          </div>
        </div>
      </div>

      <div css={classes.tabsWrapper}>
        {(isBrandLoading || isSubCatLoading) && subCategoryList?.length === 0 && (
          <Box
            sx={{
              display: "flex",
              gap: "8px",
              px: 2,
              py: 1,
              borderBottom: "1px solid rgba(0,0,0,0.08)",
            }}
          >
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton
                key={i}
                variant="rounded"
                width={90}
                height={28}
                sx={{
                  borderRadius: "16px",
                  bgcolor: "rgba(0,0,0,0.07)",
                  flexShrink: 0,
                }}
              />
            ))}
          </Box>
        )}
        <TabView
          tabs={visibleTabs}
          onTabChane={onTabChange}
          subUuid={subCatActive}
          setTabindexs={setTabindexs}
          tabIndex={tabIndexs}
          renderActiveTabContent={(activeTab) =>
            activeTab?.uuid === doYouKnowTabUuid ? (
              <div css={classes.offerCardsWrapper}>
                <DoYouKnowPlaceholder
                  title="Do you Know"
                  isConfigured={isDoYouKnowConfigured}
                  isLoading={isDoYouKnowLoading}
                  errorMessage={doYouKnowError?.message}
                  hasSelectedBrand={selBrand?.length > 0}
                  hasData={hasDoYouKnowData}
                  doYouKnowData={doYouKnowData}
                />
              </div>
            ) : activeTab?.uuid === quickOffersTabUuid ? (
              <div css={classes.offerCardsWrapper}>
                <CouponsList
                  isLoading={isQuickOffersLoading}
                  errorMessage={quickOffersError?.message}
                  hasSelectedBrand={selBrand?.length > 0}
                  quickOffersData={quickOffersData}
                  promotionsData={promotionsData}
                  storeUuid={selBrand?.[0]}
                  token={userDetails?.token}
                />
              </div>
            ) : (
              <div css={classes.offerCardsWrapper}>
                {isMailLoading === true && (
                  <>
                    {Array.from({ length: 8 }).map((_, i) => (
                      <Skeleton
                        key={i}
                        variant="rounded"
                        width={240}
                        height={280}
                        sx={{
                          borderRadius: "12px",
                          bgcolor: "rgba(0,0,0,0.07)",
                          flexShrink: 0,
                        }}
                      />
                    ))}
                  </>
                )}
                {isMailLoading === false &&
                  mailList?.length > 0 &&
                  mailList.map((_item, idx) => {
                    if (!_item?.is_active) return <></>;
                    return (
                      <OfferCard
                        key={_item?.uuid || idx}
                        isRedeemed={_item?.is_seen === "true"}
                        item={_item}
                        UnsubscribeMailClick={() => onUnsubscribeMail(_item)}
                        show={subscribeshow}
                        setShow={(e1) => setSubscribeShow(e1)}
                        showUnSuscribe={true}
                        isFavourite={_item?.is_favourite === "true"}
                        onFavouriteMailToggle={(e) =>
                          onFavouriteMailToggle(e, _item?.uuid, _item)
                        }
                        isLocation={() => {}}
                        message={_item?.message}
                        onClick={() => onOfferCardClick(_item, idx)}
                      />
                    );
                  })}

                {mailCount > 15 && (
                  <div css={[classes.moreMail]}>
                    <IconButton aria-label="more" onClick={onMoreMailsClick}>
                      <ArrowForwardIosIcon />
                    </IconButton>
                  </div>
                )}
                {mailCount === 0 && isMailLoading === false && (
                  <div
                    css={[
                      classes.noResult,
                      {
                        background: "none",
                        backdropFilter: "none",
                        WebkitBackdropFilter: "none",
                        border: "none",
                        boxShadow: "none",
                      },
                    ]}
                  >
                    <div css={classes.noResultIcon}>
                      <MarkEmailUnreadOutlinedIcon sx={{ fontSize: "1.5rem" }} />
                    </div>
                    <p css={classes.noResultTitle}>No Results Found</p>
                    <p css={classes.noResultSub}>
                      There are no mails matching your current filters.
                    </p>
                  </div>
                )}
              </div>
            )
          }
        />
      </div>
    </>
  );
};

MailGrid.propTypes = {
  classes: PropTypes.object.isRequired,
  tabs: PropTypes.array,
  subCategoryList: PropTypes.array,
  isSubCatLoading: PropTypes.bool,
  isBrandLoading: PropTypes.bool,
  mailList: PropTypes.array,
  mailCount: PropTypes.number,
  isMailLoading: PropTypes.bool,
  subCatActive: PropTypes.string,
  tabIndexs: PropTypes.number,
  setTabindexs: PropTypes.func.isRequired,
  checkseen: PropTypes.bool,
  onActivefunct: PropTypes.func.isRequired,
  totalRedeemedPoints: PropTypes.number,
  totalMailCount: PropTypes.number,
  unreadMailCount: PropTypes.number,
  subscribeshow: PropTypes.bool,
  setSubscribeShow: PropTypes.func.isRequired,
  selBrand: PropTypes.array,
  selCategory: PropTypes.string,
  selCountry: PropTypes.string,
  selState: PropTypes.string,
  selCity: PropTypes.string,
  selCounty: PropTypes.string,
  userDetails: PropTypes.object,
  onTabChange: PropTypes.func.isRequired,
  onFavouriteMailToggle: PropTypes.func.isRequired,
  onUnsubscribeMail: PropTypes.func.isRequired,
  onOfferCardClick: PropTypes.func.isRequired,
  onMoreMailsClick: PropTypes.func.isRequired,
  doYouKnowTabUuid: PropTypes.string,
  isDoYouKnowConfigured: PropTypes.bool,
  isDoYouKnowLoading: PropTypes.bool,
  doYouKnowError: PropTypes.object,
  hasDoYouKnowData: PropTypes.bool,
  doYouKnowData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  quickOffersTabUuid: PropTypes.string,
  isQuickOffersLoading: PropTypes.bool,
  quickOffersError: PropTypes.object,
  quickOffersData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  promotionsData: PropTypes.object,
};

export default MailGrid;
